import { useState } from "react";
import { Link } from "react-router-dom";
import { Icon, Logo, Mark, BlobField, Button } from "../components/ui";
import { familyService } from "../services/familyService";
import { validateRequiredForm } from "../utils/validate";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!validateRequiredForm(e.currentTarget)) return;
    setBusy(true);
    try {
      await familyService.requestReset(email.trim());
      setDone(true);
    } catch {
      setDone(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-hero on-dark">
        <BlobField />
        <div className="login-hero-inner">
          <div className="hero-brand">
            <Mark size={52} variant="amber" />
            <Logo variant="white" height={44} />
          </div>
          <div className="hero-spacer">
            <p className="eyebrow on-dark">Family Portal</p>
            <h1 className="display hero-title">
              We'll help you back<br />into your account.
            </h1>
          </div>
          <p className="hero-tagline">Steps towards a bright future.</p>
        </div>
      </div>

      <div className="login-form-side">
        {done ? (
          <div className="login-card auth-done">
            <span className="icon-circle lg icon-center"><Icon name="mail" className="ico-28" /></span>
            <h2 className="mt-24">Check your inbox</h2>
            <p className="muted mt-12">
              If that email is registered with us, we've sent a link to reset your password.
            </p>
            <div className="mt-28">
              <Button variant="primary" block onClick={() => (window.location.href = "/login")}>Back to sign in</Button>
            </div>
          </div>
        ) : (
          <form className="login-card" onSubmit={submit} noValidate>
            <p className="eyebrow">Forgot password</p>
            <h2 className="auth-h2">Reset your password</h2>
            <p className="auth-intro">
              Enter your email and we'll send you a secure link to set a new password.
            </p>
            <div className="form-field--lg">
              <label className="field-label">Email address</label>
              <input className="input" type="email" name="email" value={email} required
                onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
            </div>
            <Button variant="primary" block type="submit" disabled={busy} iconRight={busy ? null : "chevronRight"}>
              {busy ? "Sending…" : "Send reset link"}
            </Button>
            <hr className="divider divider-lg" />
            <p className="signin-alt">
              <Link to="/login" className="link-strong">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
